import middleware from "../../../shared/middleware";
import errorConstants from "../../../shared/constants/error";
const { videoStreamHeartBeat } = middleware;
const { AVS_ERROR_CODES } = errorConstants;

class PcError extends Error {
  constructor(message, code, entitlement) {
    super(message);
    this.code = code;
    this.entitlement = entitlement;
  }
}

/**
 * Calls the heartbeat API to check if the current program is parental control blocked,
 * in which case an error is thrown.
 * @param {Object} appProvider
 * @param {String|Number} channelId
 * @param {String|Number} assetId
 * @param {String} parentalPin
 * @param {Object} cancelTokenSource
 * @param {Function} setPCBlocked
 * @returns {Promise}
 */
export const handleHeartBeat = (appProvider, channelId, assetId, parentalPin, cancelTokenSource, setPCBlocked) => {
  return videoStreamHeartBeat(appProvider, "LIVE", channelId, assetId, parentalPin, cancelTokenSource).then(
    (result) => {
      if (result?.data?.resultCode === "KO") {
        return Promise.reject({
          message: result.data.message,
          type: "Server",
          code: result.data.errorDescription,
          params: result.data.resultObj,
        });
      }

      const entitlement = result?.data?.resultObj?.entitlement;
      if (entitlement?.isPCBlocked) {
        // The heartbeat endpoint does not return an error if an incorrect PIN is passed,
        // so we need to throw an error manually
        throw new PcError(AVS_ERROR_CODES.USER_NO_RIGHTS, AVS_ERROR_CODES.USER_NO_RIGHTS, entitlement);
      } else {
        setPCBlocked(false);
      }
    }
  );
};
